export const persons = [
  {
    path: '/persons',
    component: () => import(/* webpackChunkName: "persons" */ '@/views/persons/Persons'),
  },
]
